import type { DividedCollapsedContacts } from './collapse-contacts';
import type { WithCollapsedAuthContact, WithCollapsedAuthResourceContact } from './contacts';
import { toCollapsedContact } from './contacts';

export function collapseDuplicateAuthContacts(
  dividedContacts: DividedCollapsedContacts
): DividedCollapsedContacts {
  const { members, authContacts, authResourceContacts, userContacts, unknownContacts } = dividedContacts;

  const resultAuthContacts: WithCollapsedAuthContact[] = [];
  const resultAuthResources: WithCollapsedAuthResourceContact[] = [];

  const groupMap = new Map<
    string,
    {
      resource?: WithCollapsedAuthResourceContact;
      contacts: WithCollapsedAuthContact[];
    }
  >();

  for (const contact of authContacts) {
    const key = `${contact.email.toLowerCase()}|${contact.name}`;

    if (!groupMap.has(key)) {
      groupMap.set(key, { contacts: [] });
    }

    groupMap.get(key)!.contacts.push(contact);
  }

  for (const contact of authResourceContacts) {
    const key = `${contact.email.toLowerCase()}|${contact.name}`;

    if (!groupMap.has(key)) {
      groupMap.set(key, { contacts: [] });
    }

    const group = groupMap.get(key)!;

    if (group.resource) {
      group.resource.collapsedContacts = group.resource.collapsedContacts.concat(
        contact.collapsedContacts,
        toCollapsedContact(contact)
      );
    } else {
      group.resource = contact;
    }
  }

  for (const { resource, contacts } of groupMap.values()) {
    if (resource) {
      resource.collapsedContacts = resource.collapsedContacts.concat(
        contacts.flatMap((c) => [toCollapsedContact(c), ...c.collapsedContacts])
      );

      resultAuthResources.push(resource);
    } else if (contacts.length > 0) {
      const mainContact = contacts[0];

      mainContact.collapsedContacts = mainContact.collapsedContacts.concat(
        contacts.slice(1).flatMap((c) => [toCollapsedContact(c), ...c.collapsedContacts])
      );

      resultAuthContacts.push(mainContact);
    }
  }

  return {
    members,
    authContacts: resultAuthContacts,
    authResourceContacts: resultAuthResources,
    userContacts,
    unknownContacts
  };
}
